import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3164042"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_cache-loader@4.1.0_webpack@4.47.0__css-load_6a40f12940938af3ce60f97513d79b51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports